import React from 'react'
import { EntregaContextProvider } from './EntregaContext'
import { PickingContextProvider } from './PickingContext'
import { OrdemColetaProvider } from './OrdemColetaContext'
import { EstoqueContextProvider } from './EstoqueContext'
import { DashboardContextProvider } from './DashboardContext'

/**
 * GlobalContextProvider
 *
 * Este provider global envolve todos os contextos da aplicação,
 * garantindo que os estados sejam mantidos independente da navegação
 * entre diferentes módulos (Picking, Entregas, Estoque, Ordem Coleta, etc.)
 */
export const GlobalContextProvider = ({ children }) => {
  return (
    <EntregaContextProvider>
      <PickingContextProvider>
        <OrdemColetaProvider>
          <EstoqueContextProvider>
            <DashboardContextProvider>{children}</DashboardContextProvider>
          </EstoqueContextProvider>
        </OrdemColetaProvider>
      </PickingContextProvider>
    </EntregaContextProvider>
  )
}
